export enum DepartmentSelectionType {
  Single,
  Multiple,
}
